// extracted by mini-css-extract-plugin
export default {"walletLogo":"mobileWalletButton__walletLogo__lHi49","unsupportedMessage":"mobileWalletButton__unsupportedMessage__rmUkw"};